import FormValidateMixin from '@/Core/mixins/FormValidate'
import { Group } from '@/Modules/UsersManager/models'
import * as _ from 'lodash-es'
import { Component, mixins, Prop, Vue, Watch } from 'types-vue'

@Component
export default class GroupForm extends mixins(FormValidateMixin) {

  @Prop({ type: String, default: 'Guardar' }) protected submitButtonText: string
  @Prop({ type: Boolean, default: false }) protected loading: boolean
  @Prop() protected value: Group

  protected disableSubmitButton: boolean = true
  protected form: Group = { name: '', description: '' }
  protected rules = {
    groupName: [{ required: true, message: 'El nombre es obligatorio', trigger: 'change' }],
    description: [{ required: true, trigger: 'blur', message: 'La descripcion es obligatoria' }]
  }

  @Watch('value', { immediate: true })
  protected onChangeDefault() {
    if (_.isNil(this.value)) return
    
    this.form = {
      name: this.value.name,
      description: this.value.description
    }
  }

  protected async onSubmit() {
    if (!await this.validateForm()) return

    this.$emit('input', this.form)
    this.$emit('submit', this.form)
  }

  protected onInput() {
    this.disableSubmitButton = false
  }


  protected destroyed() {
    this.form = { name: '', description: '' }
  }

}